module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-700.b36aa291.svg";